import * as React from 'react';
import { QuestionDropdownModel, ItemValue } from 'survey-core';
import { SurveyQuestionElementBase } from 'survey-react-ui';
import { Box, FormControl, FormHelperText, Select, InputLabel, MenuItem, styled } from '@material-ui/core';

export const TYPE = 'mui-select';
const noValue = 'N/A';

export class MuiSelectModel extends QuestionDropdownModel {
  getType(): string {
    return TYPE;
  }
}

const StyledFormHelperText = styled(FormHelperText)({
  maxWidth: 750
});

export class MuiSelect extends SurveyQuestionElementBase {
  constructor(props: any) {
    super(props);
    this.handleChange = this.handleChange.bind(this);

    if ((!this.question.value || this.question.value === noValue) && this.question.choices[0].value) {
      this.question.value = this.question.choices[0].value;
    }
  }
  get question() {
    return this.questionBase;
  }

  get choices() {
    return this.question.choices;
  }

  handleChange({ target: { value } }: React.ChangeEvent<HTMLInputElement>) {
    this.question.value = value;
  }

  protected renderElement(): JSX.Element | null {
    const { value = '', title, isRequired, selectedItem } = this.question;

    return (
      <>
        <Box width={550} mb={1}>
          <FormControl variant="filled" fullWidth>
            <InputLabel>{title}</InputLabel>
            <Select
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left'
                },
                getContentAnchorEl: null
              }}
              value={value}
              onChange={this.handleChange}
              required={isRequired}
            >
              {this.choices
                .filter(({ visible }: ItemValue) => visible)
                .map(({ value, text }: ItemValue) => (
                  <MenuItem key={value} value={value}>
                    {text}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Box>
        {selectedItem && selectedItem.tooltip && <StyledFormHelperText>{selectedItem.tooltip}</StyledFormHelperText>}
      </>
    );
  }
}
